import React, { useCallback} from 'react';
import { View} from 'react-native';
import get from 'lodash/get';
import RoomRankerTableWrapper from './RoomRankerTableWrapper';
import FeedBackGridLoader from '../../FeedBackList/components/Loader';
import GridLayout from '../../../components/GridLayout';

const RoomRanker = ({ config, isConfigLoading, applied_filter_values, applied_filters, filtersLoading }) => {
  const widget_list = get(config, 'widgetList', []);

  const renderItem = useCallback(
    ({item}) => {
      switch (item.type) {
        case 'ROOM_RANKER_TABLE':
          return (
            <RoomRankerTableWrapper
              itemData={item}
              reduxData={get(config, get(item, 'widgetId', ''), {})}
              applied_filter_values={applied_filter_values}
              applied_filters={applied_filters}
            />
          );
        default:
          return null;
      }
    },
    [config, applied_filter_values,applied_filters]
  );

  const renderContent = () => { 
  if (filtersLoading || isConfigLoading || Object.keys(applied_filter_values || {}).length === 0) {
      return (
        <View>
          <FeedBackGridLoader />
        </View>
      );
    }
    return <GridLayout data={widget_list} gap={30} renderItem={renderItem} />;
  };

  return <View style={{ paddingHorizontal: 20 }}>{renderContent()} </View>;
};

export default RoomRanker;